export const actionTypes = {
  SHOW_PROPERTY_COUNT: 'SHOW_PROPERTY_COUNT',
  SEARCH_PROPERTY_LOCATION: 'SEARCH_PROPERTY_LOCATION',
  SEARCH_PROPERTY_DATERANGE: 'SEARCH_PROPERTY_DATERANGE',
  SEARCH_PROPERTY_GUEST: 'SEARCH_PROPERTY_GUEST',
  SEARCH_FILLTER_PRICE: 'SEARCH_FILLTER_PRICE',
  SEARCH_FILTER_VIEW: 'SEARCH_FILTER_VIEW',
  SEARCH_PROPERTY_TRAVELING: 'SEARCH_PROPERTY_TRAVELING',
  SEARCH_FILLTER_AMENITIES: 'SEARCH_FILLTER_AMENITIES',
  SEARCH_FILTER_SORT_BY: 'SEARCH_FILTER_SORT_BY',
  SEARCH_PAGINATION_LIMIT: 'SEARCH_PAGINATION_LIMIT',
  SEARCH_PAGINATION_OFFSET: 'SEARCH_PAGINATION_OFFSET'
};

/*
 * Action creators for login
 */
export function setPropertiesCount(data: any) {
  return {
    type: actionTypes.SHOW_PROPERTY_COUNT,
    data
  };
}

export function setFilterSortBy(data: string) {
  return {
    type: actionTypes.SEARCH_FILTER_SORT_BY,
    data
  };
}

export function setFilterView(data: string) {
  return {
    type: actionTypes.SEARCH_FILTER_VIEW,
    data
  };
}

export function setPropertiesLocation(data: any) {
  return {
    type: actionTypes.SEARCH_PROPERTY_LOCATION,
    data
  };
}

export function setPropertiesDateRange(data: any) {
  return {
    type: actionTypes.SEARCH_PROPERTY_DATERANGE,
    data
  };
}

export function setSearchFillterPrice(data: any) {
  return {
    type: actionTypes.SEARCH_FILLTER_PRICE,
    data
  };
}

export function setSearchFillterAmenities(data: any) {
  return {
    type: actionTypes.SEARCH_FILLTER_AMENITIES,
    data
  };
}

export function setPropertiesGuests(title: string, count: number) {
  return {
    type: actionTypes.SEARCH_PROPERTY_GUEST,
    data: { title, count }
  };
}

export function setPropertiesTraveling(forId: string, status: boolean) {
  return {
    type: actionTypes.SEARCH_PROPERTY_TRAVELING,
    data: { forId, status }
  };
}

export function setPaginationLimit(data: number) {
  return {
    type: actionTypes.SEARCH_PAGINATION_LIMIT,
    data
  };
}

export function setPaginationOffset(data: number) {
  return {
    type: actionTypes.SEARCH_PAGINATION_OFFSET,
    data
  };
}

export const setSerchProperties = () => {
  return (dispatch: any, getState: any) => {
    const {
      result: {
        propertyLocation,
        propertyDaterange,
        totalGuest,
        bedroomCount,
        bathroomCount,
        bedCount,
        price,
        amenitiesData,
        amenities,
        sortBy,
        adultsCount,
        childrenCount,
        babiesCount,
        petsCount,
        paginationLimit,
        paginationOffset
      }
    } = getState();

    let searchStr = '';
    let isAmentiesSet = false;
    if (propertyLocation) {
      searchStr += `location=${propertyLocation}`;
    }
    if (propertyDaterange) {
      searchStr += `${searchStr === '' ? '' : '&'}checkInDate=${propertyDaterange.start}&checkOutDate=${propertyDaterange.end}`;
    }
    if (totalGuest) {
      searchStr += `${searchStr === '' ? '' : '&'}minimumGuests=${totalGuest}`;
    }
    if (adultsCount) {
      searchStr += `${searchStr === '' ? '' : '&'}adultsCount=${adultsCount}`;
    }
    if (childrenCount) {
      searchStr += `${searchStr === '' ? '' : '&'}childrenCount=${childrenCount}`;
    }
    if (babiesCount) {
      searchStr += `${searchStr === '' ? '' : '&'}babiesCount=${babiesCount}`;
    }
    if (petsCount) {
      searchStr += `${searchStr === '' ? '' : '&'}petsCount=${petsCount}`;
    }
    if (bedroomCount) {
      searchStr += `${searchStr === '' ? '' : '&'}minimumBedrooms=${bedroomCount}`;
    }
    if (bedCount) {
      searchStr += `${searchStr === '' ? '' : '&'}minimumBeds=${bedCount}`;
    }
    if (bathroomCount) {
      searchStr += `${searchStr === '' ? '' : '&'}minimumBathrooms=${bathroomCount}`;
    }
    if (price[0] > 59 || price[0] < 59 || price[1] > 799 || price[1] < 799) {
      searchStr += `${searchStr === '' ? '' : '&'}minimumBaseDailyRate=${price[0]}&maximumBaseDailyRate=${price[1]}`;
    }
    if (paginationLimit) {
      searchStr += `${paginationLimit === '' ? '' : '&'}limit=${paginationLimit}`;
    }
    if (paginationOffset) {
      searchStr += `${paginationOffset === '' ? '' : '&'}offSet=${paginationOffset}`;
    }
    if (sortBy) {
      searchStr += `${searchStr === '' ? '' : '&'}sort=${sortBy}`;
    }
    if (amenitiesData.length > 0) {
      let checkList = '';
      for (let i = 0; i < amenitiesData.length; i++) {
        if (amenitiesData[i].status) {
          if (amenities.length === 0) {
            amenities.push(amenitiesData[i].key);
          } else if (amenities.indexOf(amenitiesData[i].key) < 0) {
            amenities.push(amenitiesData[i].key);
          }
          isAmentiesSet = true;
        } else {
          const index = amenities.indexOf(amenitiesData[i].key);
          if (index > -1) {
            amenities.splice(index, 1);
          }
        }
      }
      if (amenities.length > 0 && isAmentiesSet) {
        let selectedAmenties = amenities.join(',');
        searchStr += `${searchStr === '' ? '' : '&'}customAmenities=${selectedAmenties}`;
      }
    }
    return searchStr;
  };
};

export const getSearchPropertiesToSave = () => {
  return (dispatch: any, getState: any) => {
    const {
      result: { propertyLocation, propertyDaterange, totalGuest, adultsCount, childrenCount, babiesCount, petsCount }
    } = getState();

    let searchObj = {
      propertyLocation,
      propertyDaterange,
      totalGuest,
      adultsCount,
      childrenCount,
      babiesCount,
      petsCount
    };

    return searchObj;
  };
};

export const saveSerchProperties = (search: any) => {
  return (dispatch: any) => {
    const urlParams = new URLSearchParams(search);
    const location = urlParams.get('location');
    const checkInDate = urlParams.get('checkInDate');
    const checkOutDate = urlParams.get('checkOutDate');
    const adultsCount = urlParams.get('adultsCount');
    const childrenCount = urlParams.get('childrenCount');
    const babiesCount = urlParams.get('babiesCount');
    const petsCount = urlParams.get('petsCount');
    const paginationLimit = urlParams.get('limit');
    const paginationOffset = urlParams.get('offSet');

    dispatch(setPropertiesGuests('Adults', parseInt(adultsCount || '0')));
    dispatch(setPropertiesGuests('Children', parseInt(childrenCount || '0')));
    dispatch(setPropertiesGuests('Babies', parseInt(babiesCount || '0')));
    dispatch(setPropertiesGuests('Pets', parseInt(petsCount || '0')));
    dispatch(setPropertiesLocation(location));
    if (checkInDate && checkOutDate) {
      dispatch(setPropertiesDateRange({ start: checkInDate, end: checkOutDate }));
    } else {
      dispatch(setPropertiesDateRange(null));
    }

    if (paginationLimit) {
      dispatch(setPaginationLimit(parseInt(paginationLimit)));
    }
    if (paginationOffset) {
      dispatch(setPaginationOffset(parseInt(paginationOffset)));
    }
  };
};
